<template>
    <div class="product-item">
        <Row>
            <i-col v-for="(item,index) in goods" :key="index" :span="24" style="padding: 20px 0 20px 0;">
                <i-col class="product-img" :md="10" :sm="24" :xs="24">
                    <img :src="item.goods_img" alt="" width="100%">
                </i-col>
                <i-col class="product-desc" :md="14" :sm="24" :xs="24" style="padding-left: 24px;">
                    <h3>{{item.goods_name}}</h3>
                    <p class="product-desc-item">{{item.goods_remark}} </p>
                    <!--<p class="product-desc-item text-primary">-->
                        <!--<a @click="more(item.goods_alias,item.goods_id)">{{$t('more')}}&gt;</a>-->
                    <!--</p>-->
                    <p class="product-desc-item">
                        <button class="btn btn-primary btn-sm" @click="buyNow(item.goods_id)" v-if="item.store_count > 0">{{$t('buy_now')}}</button>
                        <button class="btn btn-gray btn-sm" v-else>{{$t('store_mainpage_out_of_stock')}}</button>
                    </p>
                </i-col>
            </i-col>
        </Row>
    </div>
</template>
<script>
    import Signature from '../../../lib/Signature'

    export default {
        data () {
            return {
                goods: []
            }
        },
        methods: {
            buyNow (id) {
                if (this.Local.get('users')=== null) {
                    this.$Message.error(this.$t('user_message_please_login'))
                    this.$router.push({
                        name: 'Home',
                    })
                }else{
                    this.$router.push({
                        name: 'Settlement',
                        query: {
                            goods_id: id,
                            number: 1
                        }
                    })
                }

            },
            more (alias,id) {
                this.$router.push({
                    path: '/product/' + alias+'?id='+id
                })
            },
            fetchData () {
                let data = {}
                const module = 'index/search/search'
                data.sub_time = Signature.timestamp()
                data.user_id = this.Local.getUserId()
                data.content = this.$route.query.q
                data.token = this.Local.getUserToken()
                data.sign = Signature.create(module, data.sub_time)
                data.lang = this.$i18n.locale
                this.$http.get(process.env.BASEURL + module, {
                    params: data
                })

                .then(function (resp) {
                    if (parseInt(resp.data.code) === 2000) {
                        this.goods = resp.data.data.goods_list
                        this.Local.set('goods_count', resp.data.data.goods_list.length)
                    }
                }.bind(this))
            }
        },
        watch: {
            '$route': function (to, from) {
                this.fetchData()
            }
        },
        created () {
            this.fetchData()
        }
    }
</script>
<style scoped lang="scss">
    @import "../../../scss/common";

    .product-item {
        display: flex;
        align-items: flex-start;
        .product-img {
            width: 200px;
        }
        .product-desc {
            h3 {
                font-size: 24px;
                color: #1F2D3D;
                font-weight: 500;
            }
            .product-desc-item {
                font-size: 16px;
                line-height: 2;
                min-width: 50%;
                overflow : hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                button{
                    max-width: 150px;
                    width: 100%;
                    font-size: 20px;
                    margin-top: 10px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// ProductItem.vue?74dbdb60